import {Component} from "@/lib/types/statuspages.ts";

/**
 * Whether any component in the tree plots a response time sparkline, mirroring what `ComponentItem`
 * actually renders: a leaf carrying at least one data point. Groups have no check of their own, so
 * they never plot one.
 *
 * Subcomponents count even though they only render once their group is expanded — the column header
 * would otherwise appear and vanish as rows are toggled open.
 */
export const hasResponseTimeGraphs = (components: Component[]): boolean =>
  components.some(
    (component) =>
      (!component.is_group && !!component.response_time_data?.length) ||
      hasResponseTimeGraphs(component.subcomponents ?? [])
  );
